'use client';

import { useTranslations } from 'next-intl';
import { ComponentProps } from 'react';
import { Text } from '@/lib/ui-kit/text';
import { cn } from '@/lib/ui-kit/utils';

type EmptyAsksProps = ComponentProps<'div'>;

export const EmptyAsks = ({ className, ...props }: EmptyAsksProps) => {
  const t = useTranslations('orderBook');
  return (
    <div
      className={cn(
        'flex h-9 w-full flex-1 items-center justify-center p-4 text-v2-text-secondary',
        className,
      )}
      {...props}
    >
      <Text variant="label-md">{t('noAsks')}</Text>
    </div>
  );
};
